import { toTitleCase } from "../../../../Utils/stringUtls";

const ProjectDetailsOverview = ({ data }) => {
  const {
    pd_client_name,
    pd_region,
    pd_team_avail,
    pd_pid,
    pd_ticket_num,
    pd_kick_off,
    pd_go_live,
    pd_sales_rep,
    pd_pmo,
    pd_solution_architect,
    pd_po_resource,
    pd_quality_engineer,
    pd_account_manager,
    pd_sales_engineer,
  } = data["1_0"];
  return (
    <div className="forms-instance" style={{ color: "#111" }}>
      <div i2c-grid="grid gap-sm" className="">
        <div i2c-grid="12@md" className="fw-700 review-summary-sub-heading">
          Project Details
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Client Name</div>
          <div className="overview-val-text">
            {pd_client_name?.length ? toTitleCase(pd_client_name) : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Region</div>
          <div className="overview-val-text">
            {pd_region?.length ? toTitleCase(pd_region) : "-"}
          </div>
        </div>

        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">
            Project Team Availability
          </div>
          <div className="overview-val-text">
            {pd_team_avail?.length ? toTitleCase(pd_team_avail) : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Project ID</div>
          <div className="overview-val-text">
            {pd_pid?.length ? pd_pid.toUpperCase() : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Ticket Number</div>
          <div className="overview-val-text">
            {pd_ticket_num?.length ? toTitleCase(pd_ticket_num) : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">
            Project Kick-off Date
          </div>
          <div className="overview-val-text">{pd_kick_off}</div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">
            Go-Live Date (Projected)
          </div>
          <div className="overview-val-text">{pd_go_live}</div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">i2c Inc. Sales Rep</div>
          <div className="overview-val-text">
            {pd_sales_rep?.length ? toTitleCase(pd_sales_rep) : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">
            i2c Inc. Project Manager(s)
          </div>
          <div className="overview-val-text">
            {pd_pmo?.length ? toTitleCase(pd_pmo) : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">
            i2c Inc. Solution Architect(s)
          </div>
          <div className="overview-val-text">
            {pd_solution_architect?.length
              ? toTitleCase(pd_solution_architect)
              : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">PO Resource</div>
          <div className="overview-val-text">
            {pd_po_resource?.length ? toTitleCase(pd_po_resource) : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Quality Engineer</div>
          <div className="overview-val-text">
            {pd_quality_engineer?.length
              ? toTitleCase(pd_quality_engineer)
              : "-"}
          </div>
        </div>

        <div i2c-grid="12@md" className="overview-help-text font-bold mb-4">
          i2c Contact Details
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">
            i2c Account Manager(s)
          </div>
          <div className="overview-val-text">
            {pd_account_manager?.length ? toTitleCase(pd_account_manager) : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">i2c Sales Engineer</div>
          <div className="overview-val-text">
            {pd_sales_engineer?.length ? toTitleCase(pd_sales_engineer) : "-"}
          </div>
        </div>
      </div>
    </div>
  );
};
export default ProjectDetailsOverview;
